module.exports = __webpack_public_path__ + "img/gm.d9e94056.svg";